import StatCard from '../../Dashboard/components/StatCard'

interface StatsSummaryProps {
  totalViews: number
  uniqueVisitors: number
  avgDailyViews: number
  loading: boolean
}

function StatsSummary({ totalViews, uniqueVisitors, avgDailyViews, loading }: StatsSummaryProps) {
  return (
    <div className="stats-grid">
      <StatCard
        title="Vues totales"
        value={totalViews}
        icon="👁️"
        color="blue"
        loading={loading}
      />
      <StatCard
        title="Visiteurs uniques"
        value={uniqueVisitors}
        icon="👤"
        color="green"
        loading={loading}
      />
      <StatCard
        title="Moyenne / jour"
        value={avgDailyViews}
        icon="📈"
        color="purple"
        loading={loading}
      />
    </div>
  )
}

export default StatsSummary
